import { Flex, Tag, Text, Title } from '@collable/ui'

const SignupContentHeader = () => {
  return (
    <Flex as="header" gap={8} direction="column">
      <Tag color="primary" type="soft" size="small">
        크리에이터로 가입 진행 중
      </Tag>
      <Title size="title2" fontWeight="bold" as="h1">
        본인 인증하기
      </Title>
      <Text size="body2" color="labelAlternative">
        본인 인증을 진행해 주세요.
      </Text>
    </Flex>
  )
}

export default SignupContentHeader
